import { put, take, select } from 'redux-saga/effects';

import { TOGGLE_NOTE } from './actions';
import { SAVE_ANNOTATION_POSITION, RESET_ANNOTATION } from 'Reducers/compModels';
import { SAVE_SELECTEDHIGHLIGHT } from 'Reducers/dataModels';


function* toggle() {
  while (true) {
    const { data:{ position, selectedHighlight }} = yield take(TOGGLE_NOTE);

    const prevHighlightId = yield select(state => state.selectedHighlight.id);
    const isMain = yield select(state => state.annotation.isMain);

    if ((prevHighlightId === selectedHighlight.id) && !isMain) {      
      yield put({ type: RESET_ANNOTATION });
    } else {
      yield put({
        type: SAVE_SELECTEDHIGHLIGHT,
        data: selectedHighlight
      });

      yield put({
        type: SAVE_ANNOTATION_POSITION,
        data: {
          isMain: false,
          isOpen: true,
          textSelected: false,
          highlightClicked: false,
          noteClicked: true,
          position
        }
      });
    }  
  }
}

export default toggle;
